const eventsMixin = {
  methods: {
    onSearchChange(query) {
      if (this.searchDisabled) return;
      this.onSearch(query);
      this.adjustMobileListHeight();
      this.mobileListHeightAdjusted = true;
    },
    onReset() {
      this.selectedValue = null;
    },
    onOpen() {
      this.$refs.multiselect.pointerSet(0);
    },
    onClose() {
      if (this.url) this.resetSearch();
      this.$emit("close");
    },
    onInput(option) {
      this.$emit("input", this.eventFromOption(option));
      this.$refs.input.dispatchEvent(new Event("input", { bubbles: true }));
    },
    onSelect(option) {
      if (this.showError) this.showError = false;
      this.$emit("select", this.eventFromOption(option));
      if (this.fullscreen && this.closeOnSelect && !this.multiple)
        this.closeFullscreen();
    },
    eventFromOption(option) {
      return { target: { value: option } };
    },
    onInvalid(event) {
      event.preventDefault();
      this.showError = true;
    }
  }
};

export default eventsMixin;
